import { Component, OnInit } from '@angular/core';
import { ContentStoreService } from '@motivforce/mx-library-angular';
import { PrivacyPolicyStoreService } from 'src/app/core/store/privacy-policy-store.service';

import { TermsAndConditionsStoreService } from '../../../store/terms-and-conditions-store.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  year: string;

  termsAndConditionsUrl$ = this.termsAndConditionsStore.termsAndConditionsUrl$;
  privacyPolicyUrl$ = this.privacyPolicyStore.privacyPolicy$;

  constructor(
    private termsAndConditionsStore: TermsAndConditionsStoreService,
    private privacyPolicyStore: PrivacyPolicyStoreService,
    private contentStore: ContentStoreService
  ) {}

  ngOnInit(): void {
    this.year = new Date().getFullYear().toString();
  }
}
